import { TradeDocumentDeliveryState } from './reducer'

export const getDeliveries = (state: {
  tradeDocumentDelivery: TradeDocumentDeliveryState
}) => state.tradeDocumentDelivery.deliveries
